<template>
  <div class="goods-list">
    <div class="clear head">
      <span class="fl goods-type">{{ name }}</span>
      <div class="fr" @click="sendGioHandle(type, name)">
        <router-link
          v-if="type === 1"
          :target="isFeishuOrDingding ? '_self' : '_blank'"
          to="/product/list?channelId=3&sortField=5&goodsType=1"
          >{{TLang('热门商品','my')}}</router-link
        >
        <router-link
          v-else
          :target="isFeishuOrDingding ? '_self' : '_blank'"
          to="/product/list?channelId=3&sortField=5&goodsType=0"
          >{{TLang('热门商品','my')}}</router-link
        >
        <!-- <span class="line"></span> -->
        <!-- <router-link v-if="type === 1" to="/product/list?channelId=3&goodsType=1&sortField=3">最新上架</router-link>
        <router-link v-else to="/product/list?channelId=3&sortField=3&goodsType=0">最新上架</router-link> -->
      </div>
    </div>

    <ul class="goods-list-wrap clear">
      <li
        class="fl"
        v-for="item in goodsList"
        :key="item.goodsId"
        @click="toGoodsDetail(item)"
      >
        <div class="goods-img-wrap">
          <img class="goods-img" :src="item.imgUrl" alt="" />
          <img class="soldOut" :src="require('@assets/images/allGone.png')" alt v-if="item.bizStock === 0" />
          <!-- 爆炸贴图片 -->
          <Sticker v-if="type === 0" :imgList="item.stickerImgList" />
        </div>

        <div class="pre-sale-wrap">
          <div
            :class="CookiesOne === 'en-US' ? 'pre-sale pre-sale-one': 'pre-sale'"
            v-if="item.advanceSale && item.sendGoodsTimeStart"
          >
            {{ TLang('起发货1','my') }}{{ item.sendGoodsTimeStart | date }}{{ TLang('起发货2','my') }}
          </div>
        </div>
        <p class="goods-name" :title="item.goodsName">
          <i
            v-for="(tag, index) in item.tags"
            :key="index"
            :style="{ fontStyle: 'normal'}"
          >
            <SingleTag :show="tag.mktFrontType === 9005" :datas="tag" />
          </i>
          {{ item.goodsName }}
        </p>
        <p class="goods-point">{{ item.goodsTitle }}</p>
        <div class="goods-flag">
          <!-- <img
            class="goods-item-flag"
            v-for="(tag, index) in item.tags"
            v-show="tag.mktIcon"
            :src="tag.mktIcon"
            :key="index"
          /> -->
          <span
            v-for="(tag, index) in item.tags"
            :key="index"
            class="goods-item-flag"
          >
            <SingleTag :show="tagShow(tag, true)" :datas="tag" />
          </span>
        </div>
        <div v-if="item && item.groupItem === 'Y'">
          <FppGoodsPrice 
            :type="item.groupItemClassStyle"
            :price="item.groupItemPrice"
            :limitPrice="item.groupItemPriceLimit"
            :unionIcon="union_icon || require('@assets/images/fudou.png')"
            :showSymbolIcon="item.groupItemShowRmbSymbol"
          />
        </div>
        <div v-else>
          <img
            class="fudou"
            :src="union_icon || require('@assets/images/fudou.png')"
            alt=""
          />
          <span class="goods-price">{{
            item.promPrice && item.tags && item.tags.length > 0
              ? ((item.promPrice || 0) * union_scale).toFixed(2)
              : (item.sellingPrice * union_scale || 0).toFixed(2)
          }}</span>
          <!-- 划线价 -->
          <span class="line-price-box" v-if="item.promPrice && item.tags && item.tags.length > 0">
            <img
              :src="union_icon || require('@assets/images/fudou.png')"
              alt=""
              class="fudou2"
            />
            <span class="line-price-num">{{
              (item.salePrice || item.sellingPrice * union_scale || 0).toFixed(
                2
              )
            }}</span>
          </span>
        </div>
        <DiscountPrice 
          :discountPrice="item.discountPrice"
          :discount="item.discount"
          :discountTagShow="item.discountTagShow"
          :mktTagShow="item.mktTagShow"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Sticker from "@components/sticker";
import SingleTag from '@components/singleTag';
import FppGoodsPrice from '@components/FppGoodsPrice';
import {gioClickHandle} from '@utils';
import DiscountPrice from '../lifeIndex/DiscountPrice';
// console.log(DiscountPrice,'DiscountPrice')
export default {
  name: "goodsList",
  components: {
    Sticker,
    DiscountPrice,
    SingleTag,
    FppGoodsPrice,
  },
  data() {
    return {
      city_id:
        (Cookies.get("address") &&
          JSON.parse(Cookies.get("address") || "{}").cityId) ||
        145,
      CookiesOne:Cookies.get('df_lang')
    };
  },
  props: {
    name: String,
    type: Number,
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    /**
     * 跳转商品详情页
     * 电子券跳转老php页面   goodsType === 1
     * 实体商品跳转新的实体商品页 goodsType === 0
     * @param { Object } 商品
     */
    toGoodsDetail(goods = {}) {
      if (goods.goodsType === 1) {
        const gioParams = {
          df_channle: "生日汇",
          df_pagename: "频道首页",
          df_modulename: "楼层",
          df_elementname: "商品详情",
          df_firstCategory: "电子券",
          df_goodsname: goods.goodsName || "",
          df_spu_code: (goods.goodsId + "") || ""
        }
        // 点击楼层商品 电子券
        gioClickHandle('DF_elementClick', gioParams)
        let url = `/birthday/goods/detail/${goods.goodsId}?city=${this.city_id}`;
        if (goods.pcUrl){
          url = goods.pcUrl;
        }
        window.open(url,this.isFeishuOrDingding ? '_self' : '_blank')
        return;
      }
      window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,this.isFeishuOrDingding ? '_self' : '_blank')
    },
    sendGioHandle(type, name) {
      const gioParams = {
        df_channle: "生日汇",
        df_pagename: "频道首页",
        df_modulename: "楼层",
        df_elementname: "热门商品",
        df_firstCategory: name,
        df_firstCategoryId: type + ''
      }
      //点击热门商品
      gioClickHandle('DF_elementClick', gioParams)
    },
    tagShow(item, limitFlag) {
      let flag = false;
      // mktIcon 特价、限购、新品 || limitFlag && mktFrontType限购起购 || 300001抽奖
      if (item.mktIcon || (limitFlag && (item.mktFrontType === 9003 || item.mktFrontType === 9004))) {
        flag = true;
      }
      return flag;
    },
  },
  filters: {
    date(time) {
      const date = new Date(time);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    },
  },
};
</script>

<style lang="less" scoped>
.goods-list {
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
  .head {
    padding-bottom: 10px;
    color: #1c4a9c;
    border-bottom: 2px solid #1c4a9c;
    font-size: 16px;
    line-height: 1;
    a {
      color: #1c4a9c;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .goods-type {
    font-weight: 700;
  }
  .line {
    display: inline-block;
    width: 1px;
    height: 16px;
    background: #cccccc;
    margin: 0 19px;
    vertical-align: bottom;
  }
  .goods-list-wrap {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 25%;
      box-sizing: border-box;
      border: 1px solid #ececec;
      border-top: none;
      border-left: none;
      padding: 20px;
      position: relative;
      &:hover {
        .goods-name {
          color: #1c4a9c;
        }
      }
    }
    a {
      display: block;
    }
  }
  .goods-img-wrap {
    position: relative;
    .soldOut{
      width: 53%;
      height: 53%;
      position: absolute;
      top: 23.5%;
      left: 23.5%;
      z-index: 10
    }
  }
  .goods-img {
    width: 260px;
    height: 260px;
    margin-bottom: 5px;
  }
  /deep/.sticker-wrap img {
    width: 260px;
  }
  .pre-sale-wrap {
    background-color: #74c7fc;
    position: absolute;
    left: 20px;
    top: 256px;
    width: 260px;
  }
  .pre-sale {
    width: 200px;
    height: 24px;
    background: url("~@assets/images/birthday/pre_sale_bg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    line-height: 22px;
    color: #fff;
    font-size: 12px;
    padding-left: 78px;
    box-sizing: border-box;
  }
  .pre-sale-one{
    width: 100%;
    padding-left: 100px!important;
    background: url("~@assets/images/presale-en.png") 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .goods-name {
    color: #000;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
    margin-bottom: 4px;
  }
  .goods-point {
    color: #999;
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .goods-price {
    font-size: 20px;
    color: #FF5757;
    line-height: 1;
    display: inline-block;
  }
  .line-price-box {
    margin-top: 4px;
    position: relative;
    .fudou2 {
      width: 8px;
      height: 8px;
      margin-top: 0;
      vertical-align: middle;
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
      opacity: 0.7;
    }
    .line-price-num {
      font-size: 12px;
      margin-left: -4px;
      color: #999999;
    }
    &:after {
      content: "";
      width: 103%;
      height: 1px;
      position: absolute;
      left: -1px;
      top: 9px;
      background-color: #999999;
    }
  }
  .goods-flag {
    // display: flex;
    height: 16px;
    overflow: hidden;
    padding: 5px 14px 5px 0;
  }
  .goods-item-flag {
    // width: 34px;
    width: auto;
    min-width: 32px;
    height: 16px;
    margin-right: 6px;
    float: left;
  }
}

</style>
